// extracted by mini-css-extract-plugin
export default {"connectSection":"FooterConnect_connectSection__DyaCO","title":"FooterConnect_title__00pJJ","column":"FooterConnect_column__a9ou3","link":"FooterConnect_link__V2+9o"};